<template>
    <toolbar-option>
        <template slot="primary">
            <input
                v-model="value"
                type="text"
                placeholder="Add ID value"
                @change="setChangedData(true)"
            >
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'input-label-for',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Label For',
            value: '',
        };
    },

    watch: {
        value() {
            this.selectedElements[0].labelForNew = this.value;
            this.onOptionChange(this.value);
        },
    },

    methods: {
        onSelectedElement() {
            this.value = this.selectedElements[0].labelForNew;
        },
    },
};
</script>
